// /support - «Support»: how to reach the developer and where the answers are (BL-068, ADR-0036). A public,
// pre-rendered page; it is also the supportURL of the OpenAI plugin. The Feedback form is the one of /install:
// it shows for a signed-in user only, after the session is known (ADR-0050). No response times are promised.
import { Title } from "./Hl";
import { Link } from "react-router";
import { t } from "../i18n";
import { useSession } from "../session";
import { FeedbackForm } from "./FeedbackForm";

export function SupportPage() {
  const { me } = useSession();
  return (
    <article className="landing support-page">
      <header className="landing-hero">
        <h1><Title text={t("support.h1")} /></h1>
        <p className="hero-lead">{t("support.lead")}</p>
      </header>

      <section className="landing-section" id="contact">
        <h2>{t("support.contactTitle")}</h2>
        <p>
          {t("support.contactText")} <a href="mailto:connect@valas.team">connect@valas.team</a>. {t("support.readsAll")}
        </p>
      </section>

      <section className="landing-section" id="help">
        <h2>{t("support.helpTitle")}</h2>
        <ul>
          <li>
            <Link to="/guide">{t("support.guideLink")}</Link>
          </li>
          <li>
            <Link to="/install">{t("support.installLink")}</Link>
          </li>
        </ul>
      </section>

      <section className="landing-section" id="policies">
        <h2>{t("support.legalTitle")}</h2>
        <ul>
          <li>
            <a href="/privacy.html">{t("support.privacyLink")}</a>
          </li>
          <li>
            <a href="/terms.html">{t("support.termsLink")}</a>
          </li>
        </ul>
      </section>

      {me && (
        <section className="landing-section" id="feedback">
          <h2>{t("support.feedbackTitle")}</h2>
          <p>{t("support.signedIn")}</p>
        </section>
      )}
      <FeedbackForm signedIn={!!me} />
    </article>
  );
}
